
import React, { useRef, useEffect, useCallback } from 'react';

// Extend JSX to include the 'turbo-frame' element
declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'turbo-frame': {
        src: string | null;
        loading: "eager" | "lazy";
        disabled: boolean;
        target: string | null;
        autoscroll: boolean;
      } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export const TurboFrame: React.FC<{
  id?: string;
  src?: string;
  loading?: "eager" | "lazy";
  disabled?: boolean;
  target?: string;
  autoscroll?: boolean;
  onSubmitEnd?: EventListener
  children?: React.ReactNode;
}> = ({
  id,
  src,
  target,
  loading = "eager",
  disabled = false,
  autoscroll = false,
  onSubmitEnd = () => {},
  children,
  ...props
}) => {
  const ref = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    ref.current?.addEventListener("turbo:submit-end", onSubmitEnd || (() => {}));
    return () => {
      ref.current?.removeEventListener("turbo:submit-end", onSubmitEnd || (() => {}));
    };
  }, [ref, onSubmitEnd]);

  return (
    <turbo-frame
      {...props}
      ref={ref}
      id={id}
      src={src}
      target={target!}
      loading={loading}
      disabled={disabled}
      autoscroll={autoscroll}
    >
      
      {/* 
        TODO - "Loading" contents for the frame vs pre-rendered contents.
        There is a conceptual bug displaying the children here by default;
        the children here are intended to be the "loading" contents of the frame -
        but if the frame is *preloaded*, say, with a rendered Event form,
        then when loading picking a new timeslot, you will see the original pre-rendered
        form as the "loading" contents of the frame. Which is confusing for the user.

        See bookings/index vs bookings/new.
        { children } 
       */}
      <div />
    </turbo-frame>
  );
};

export default TurboFrame;